// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/belt-fastening-duties.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/belt-fastening-duties/belt-fastening-duties.js';

mount([g0]);
